<p class="text-center text-subtitle">
  Wachtwoord vergeten? Vul hieronder je e&#8209;mailadres in. We sturen binnen enkele minuten een e&#8209;mail waarmee
  een nieuw wachtwoord kan worden aangemaakt.
</p>

<ng-container [formGroup]="form">
  <app-input name="email" type="email" (keydown.enter)="submit()" formControlName="email">E-mailadres</app-input>
</ng-container>

<div class="login-box">
  <app-button [block]="true" (click)="submit()" onKeyUp="submit()">Aanvragen</app-button>

</div>
<a class="link hoverable text-subtitle text-center link-text-only" routerLink="/login">Terug naar login</a>
